import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

export default function BreadcrumbsNav() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <Breadcrumbs sx={{ mb: 2 }}>
      <Typography>Home</Typography>
      {pathnames.map((value, index) => {
        const label = value.charAt(0).toUpperCase() + value.slice(1);
        return <Typography key={index}>{label}</Typography>;
      })}
    </Breadcrumbs>
  );
}
